"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIToggle = _interopRequireDefault(require("UIComponents/input/UIToggle"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _underscore = require("underscore");

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _Locales = _interopRequireDefault(require("lead-flows-ui/constants/Locales"));

var _LegalConsent = require("lead-flows-ui/constants/LegalConsent");

var _LegalConsentDefaultSettings = _interopRequireDefault(require("lead-flows-ui/lib/LegalConsentDefaultSettings"));

var _LocaleUtils = require("lead-flows-ui/utils/LocaleUtils");

var _FormFieldUtils = require("lead-flows-ui/utils/FormFieldUtils");

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _ContactPropertyUtils = require("lead-flows-ui/utils/ContactPropertyUtils");

var _ContactProperties = require("lead-flows-ui/selectors/ContactProperties");

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var _LegalConsent2 = require("lead-flows-ui/selectors/LegalConsent");

var _Subscriptions = require("lead-flows-ui/actions/Subscriptions");

var _LegalConsentDefaultSettings2 = require("lead-flows-ui/actions/LegalConsentDefaultSettings");

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _SimpleTextInputWithValidation = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleTextInputWithValidation"));

var _userInfo = require("hub-http/userInfo");

var _ImageUploadManager = _interopRequireDefault(require("./FileManager/ImageUploadManager"));

var _FormFieldEditor = _interopRequireDefault(require("./formFieldManagement/FormFieldEditor"));

var _DynoFormFieldEditorPanel = _interopRequireDefault(require("./DynoFormFieldEditorPanel"));

var _GDPREditor = _interopRequireDefault(require("lead-flows-ui/components/editor/FormPanel/GDPREditor"));

var _GDPROptions = _interopRequireDefault(require("lead-flows-ui/components/editor/FormPanel/GDPROptions"));

var _RichTextEditor = _interopRequireDefault(require("lead-flows-ui/components/common/RichTextEditor"));

var FORM_DESCRIPTION_MAX_LENGTH = 1000;
var FORM_CTA_MAX_LENGTH = 80;

var DynoFormPanel = _react.default.createClass({
  displayName: "DynoFormPanel",
  propTypes: {
    addValidationError: _react.default.PropTypes.func.isRequired,
    allGates: _react.default.PropTypes.array.isRequired,
    fetchSubscriptions: _react.default.PropTypes.func.isRequired,
    formCta: _react.default.PropTypes.string,
    formDescription: _react.default.PropTypes.string,
    formFields: _react.default.PropTypes.array,
    handleImageChange: _react.default.PropTypes.func.isRequired,
    imageUrl: _react.default.PropTypes.string,
    legalConsentOptions: _react.default.PropTypes.object,
    lifecycle: _react.default.PropTypes.string,
    lifecycleProperty: _react.default.PropTypes.object.isRequired,
    locale: _react.default.PropTypes.string,
    removeValidationError: _react.default.PropTypes.func.isRequired,
    showNames: _react.default.PropTypes.bool.isRequired,
    showPhone: _react.default.PropTypes.bool.isRequired,
    subscriptionsDefinitions: _react.default.PropTypes.array.isRequired,
    type: _react.default.PropTypes.oneOf(Object.keys(_DynoTypes.default || {})).isRequired,
    updateDyno: _react.default.PropTypes.func.isRequired,
    validation: _react.default.PropTypes.object.isRequired,
    fetchLegalConsentDefaults: _react.default.PropTypes.func.isRequired,
    legalConsentDefaultSettings: _react.default.PropTypes.object.isRequired,
    isRecaptchaEnabled: _react.default.PropTypes.bool.isRequired,
    isRecaptchaConfigurable: _react.default.PropTypes.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      legalConsentOptions: null,
      validation: {}
    };
  },
  getInitialState: function getInitialState() {
    return {
      formFieldToEdit: null,
      GDPREditorVisible: false
    };
  },
  componentWillMount: function componentWillMount() {
    var _this$props = this.props,
        fetchSubscriptions = _this$props.fetchSubscriptions,
        legalConsentOptions = _this$props.legalConsentOptions,
        subscriptionsDefinitions = _this$props.subscriptionsDefinitions,
        fetchLegalConsentDefaults = _this$props.fetchLegalConsentDefaults; // eslint-disable-next-line

    var sanitizedLegalConsentOptions; // eslint-disable-next-line

    var subscriptionTypes;

    if (!subscriptionsDefinitions.length) {
      fetchSubscriptions();
    } // necessary for allready created legal consent options with `legitimateInterestSubscriptionType`
    // as a string instead of the new array of values `legitimateInterestSubscriptionTypes`


    if (legalConsentOptions && legalConsentOptions.legitimateInterestSubscriptionType) {
      subscriptionTypes = [legalConsentOptions.legitimateInterestSubscriptionType];
      sanitizedLegalConsentOptions = (0, _underscore.omit)(legalConsentOptions, 'legitimateInterestSubscriptionType');
      this.updateDynoLegalConsent((0, _extends2.default)({}, sanitizedLegalConsentOptions, {
        legitimateInterestSubscriptionTypes: subscriptionTypes
      }));
    }

    fetchLegalConsentDefaults();
  },
  addCheckbox: function addCheckbox() {
    var _this = this;

    var _this$props2 = this.props,
        legalConsentOptions = _this$props2.legalConsentOptions,
        legalConsentDefaultSettings = _this$props2.legalConsentDefaultSettings,
        locale = _this$props2.locale;
    var newCheckBox = legalConsentDefaultSettings.getCommunicationConsentCheckbox(locale);
    var legalConsentOptionsCopy = (0, _extends2.default)({}, legalConsentOptions);
    legalConsentOptionsCopy.communicationConsentCheckboxes.push(newCheckBox);
    this.updateDynoLegalConsent(legalConsentOptionsCopy, function () {
      _this.forceUpdate();
    });
  },
  deleteCheckbox: function deleteCheckbox(idx) {
    var _this2 = this;

    var legalConsentOptions = this.props.legalConsentOptions;
    var legalConsentOptionsCopy = (0, _extends2.default)({}, legalConsentOptions);
    legalConsentOptionsCopy.communicationConsentCheckboxes.splice(idx, 1);
    this.updateDynoLegalConsent(legalConsentOptionsCopy, function () {
      _this2.forceUpdate();
    });
  },
  getLegalConsentCurrentOption: function getLegalConsentCurrentOption() {
    var legalConsentOptions = this.props.legalConsentOptions;
    if (legalConsentOptions === null) return _LegalConsent.LegalConsentOptions.NONE;
    if (legalConsentOptions.isLegitimateInterest) return _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST;
    if (legalConsentOptions.processingConsentType === _LegalConsent.ProcessingConsentType.IMPLICIT) return _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT;
    if (legalConsentOptions.processingConsentType === _LegalConsent.ProcessingConsentType.REQUIRED_CHECKBOX) return _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT;
    return _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT;
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowFormEditor." + suffix;
  },
  maybeRenderImageUpload: function maybeRenderImageUpload() {
    var _typeMapping;

    var _this$props3 = this.props,
        type = _this$props3.type,
        handleImageChange = _this$props3.handleImageChange,
        imageUrl = _this$props3.imageUrl,
        addValidationError = _this$props3.addValidationError,
        removeValidationError = _this$props3.removeValidationError;
    var typeMapping = (_typeMapping = {}, (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.TOP, true), (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.BOTTOM_RIGHT, false), (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.BOTTOM_LEFT, false), (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.POP_OVER, false), _typeMapping);
    var component;

    if (typeMapping[type]) {
      component = _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('featuredImage')
        }),
        tooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('tooltip.featuredImage')
        })
      }, _react.default.createElement(_ImageUploadManager.default, {
        addValidationError: addValidationError,
        auth: (0, _userInfo.userInfoSync)(),
        imageUrl: imageUrl,
        onChange: handleImageChange,
        removeValidationError: removeValidationError
      }));
    }

    return component;
  },
  updateLocale: function updateLocale(formFields, locale, updateDyno) {
    var newFormFields = formFields.map(function (field) {
      return Object.assign({}, field, {
        label: (0, _FormFieldUtils.getFormFieldLabel)(field, locale)
      });
    });
    updateDyno({
      formFields: newFormFields,
      locale: locale
    });
    this.updateLegalConsent(this.getLegalConsentCurrentOption(), locale);
  },
  updateLifecycle: function updateLifecycle(lifecycle, updateDyno) {
    updateDyno({
      lifecycle: lifecycle
    });
  },
  updateDynoLegalConsent: function updateDynoLegalConsent(data, callback) {
    this.props.updateDyno({
      legalConsentOptions: data
    });
    if (callback) callback();
  },
  updateLegalConsent: function updateLegalConsent(legalConsentOption, locale) {
    var _this$props4 = this.props,
        subscriptionsDefinitions = _this$props4.subscriptionsDefinitions,
        legalConsentDefaultSettings = _this$props4.legalConsentDefaultSettings;

    switch (legalConsentOption) {
      case _LegalConsent.LegalConsentOptions.NONE:
        this.updateDynoLegalConsent(null);
        break;

      case _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST:
        this.updateDynoLegalConsent({
          isLegitimateInterest: true,
          legitimateInterestSubscriptionTypes: [subscriptionsDefinitions[0].id],
          legitimateInterestLegalBasis: _LegalConsent.LegitimateInterestLegalBasis.LEGITIMATE_INTEREST_PQL,
          privacyPolicyText: legalConsentDefaultSettings.getLegitimateInterestPrivacyPolicyText(locale)
        });
        break;

      case _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT:
        this.updateDynoLegalConsent({
          communicationConsentCheckboxes: [legalConsentDefaultSettings.getCommunicationConsentCheckbox(locale)],
          communicationConsentText: legalConsentDefaultSettings.getCommunicationConsentText(locale),
          privacyPolicyText: legalConsentDefaultSettings.getPrivacyPolicyText(locale),
          processingConsentText: legalConsentDefaultSettings.getImplicitProcessingConsentText(locale),
          processingConsentType: _LegalConsent.ProcessingConsentType.IMPLICIT
        });
        break;

      case _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT:
        this.updateDynoLegalConsent({
          communicationConsentCheckboxes: [legalConsentDefaultSettings.getCommunicationConsentCheckbox(locale)],
          communicationConsentText: legalConsentDefaultSettings.getCommunicationConsentText(locale),
          privacyPolicyText: legalConsentDefaultSettings.getPrivacyPolicyText(locale),
          processingConsentCheckboxLabel: legalConsentDefaultSettings.getExplicitProcessingConsentCheckboxLabel(locale),
          processingConsentFooterText: '',
          processingConsentText: legalConsentDefaultSettings.getExplicitProcessingConsentText(locale),
          processingConsentType: _LegalConsent.ProcessingConsentType.REQUIRED_CHECKBOX
        });
        break;

      default:
        break;
    }
  },
  handleLegalConsentChange: function handleLegalConsentChange(_ref) {
    var value = _ref.target.value;
    var locale = this.props.locale;
    this.updateLegalConsent(value, locale);
  },
  handleFormDescriptionChange: function handleFormDescriptionChange(value) {
    var _this$props5 = this.props,
        updateDyno = _this$props5.updateDyno,
        addValidationError = _this$props5.addValidationError,
        removeValidationError = _this$props5.removeValidationError;
    var html = value.html;
    var plain = value.plainText;
    updateDyno({
      formDescription: html
    });

    if (plain.length > FORM_DESCRIPTION_MAX_LENGTH) {
      addValidationError('formDescription', this.langKey('error.formDescriptionExceedsMaxLength'));
    } else {
      removeValidationError('formDescription');
    }
  },
  handleChangeFormCtaText: function handleChangeFormCtaText(_ref2) {
    var value = _ref2.target.value;
    var _this$props6 = this.props,
        updateDyno = _this$props6.updateDyno,
        addValidationError = _this$props6.addValidationError,
        removeValidationError = _this$props6.removeValidationError;
    updateDyno({
      formCta: value
    }, value && value.trim().length !== 0);

    if (value.length > FORM_CTA_MAX_LENGTH) {
      addValidationError('cta', this.langKey('error.exceededMaxFormCTALength'));
    } else {
      removeValidationError('cta');
    }
  },
  handleBlurFormCtaText: function handleBlurFormCtaText(_ref3) {
    var value = _ref3.target.value;
    var _this$props7 = this.props,
        addValidationError = _this$props7.addValidationError,
        removeValidationError = _this$props7.removeValidationError;

    if (value.length === 0) {
      addValidationError('cta', this.langKey('error.buttonTextFieldRequired'));
    } else if (value.length > FORM_CTA_MAX_LENGTH) {
      addValidationError('cta', this.langKey('error.exceededMaxFormCTALength'));
    } else {
      removeValidationError('cta');
    }
  },
  handleEditFormField: function handleEditFormField(name) {
    this.setState({
      formFieldToEdit: name
    });
  },
  closeFormFieldEditor: function closeFormFieldEditor() {
    this.setState({
      formFieldToEdit: null
    });
  },
  toggleGDPR: function toggleGDPR() {
    this.setState({
      GDPREditorVisible: !this.state.GDPREditorVisible
    });
  },
  maybeRenderLifecycleSelect: function maybeRenderLifecycleSelect() {
    var _this3 = this;

    var _this$props8 = this.props,
        updateDyno = _this$props8.updateDyno,
        lifecycle = _this$props8.lifecycle,
        lifecycleProperty = _this$props8.lifecycleProperty;
    return _react.default.createElement(_UIFormControl.default, {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('formLifecycleSelectorHeader')
      }),
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('tooltip.formLifecycle')
      })
    }, _react.default.createElement(_UISelect.default, {
      className: "form-lifecyle-select",
      defaultValue: lifecycle,
      onChange: function onChange(_ref4) {
        var value = _ref4.target.value;
        return _this3.updateLifecycle(value, updateDyno);
      },
      options: (0, _ContactPropertyUtils.getLifecyclePropertyOptions)(lifecycleProperty)
    }));
  },
  renderGDPREditor: function renderGDPREditor() {
    var _this$props9 = this.props,
        addValidationError = _this$props9.addValidationError,
        legalConsentOptions = _this$props9.legalConsentOptions,
        removeValidationError = _this$props9.removeValidationError,
        subscriptionsDefinitions = _this$props9.subscriptionsDefinitions,
        legalConsentDefaultSettings = _this$props9.legalConsentDefaultSettings,
        validation = _this$props9.validation,
        locale = _this$props9.locale,
        allGates = _this$props9.allGates;
    return _react.default.createElement(_GDPREditor.default, {
      addCheckbox: this.addCheckbox,
      addValidationError: addValidationError,
      closeGDPREditor: this.toggleGDPR,
      deleteCheckbox: this.deleteCheckbox,
      legalConsentOptions: legalConsentOptions,
      removeValidationError: removeValidationError,
      subscriptionsDefinitions: subscriptionsDefinitions,
      updateLegalConsent: this.updateDynoLegalConsent,
      legalConsentDefaultSettings: legalConsentDefaultSettings,
      validation: validation,
      locale: locale,
      allGates: allGates
    });
  },
  renderRecaptchaToggle: function renderRecaptchaToggle() {
    var _this$props10 = this.props,
        updateDyno = _this$props10.updateDyno,
        isRecaptchaEnabled = _this$props10.isRecaptchaEnabled,
        isRecaptchaConfigurable = _this$props10.isRecaptchaConfigurable;
    return _react.default.createElement(_UIFlex.default, {
      className: "m-top-4"
    }, _react.default.createElement("div", {
      id: "captcha-toggle"
    }, _react.default.createElement(_UITooltip.default, {
      placement: "right",
      disabled: isRecaptchaConfigurable,
      title: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('captchaDisabled')
      })
    }, _react.default.createElement(_UIToggle.default, {
      id: "captcha",
      "data-test-id": "captcha-toggle",
      disabled: !isRecaptchaConfigurable,
      onChange: function onChange() {
        return updateDyno({
          captchaEnabled: !isRecaptchaEnabled
        });
      },
      checked: isRecaptchaEnabled,
      size: "extra-small",
      className: "m-right-4"
    })), _react.default.createElement(_UIFormLabel.default, {
      htmlFor: "captcha",
      className: "font-weight-normal"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('captchaLabel')
    }))));
  },
  render: function render() {
    var _this4 = this;

    var _this$props11 = this.props,
        formDescription = _this$props11.formDescription,
        formCta = _this$props11.formCta,
        updateDyno = _this$props11.updateDyno,
        locale = _this$props11.locale,
        formFields = _this$props11.formFields,
        validation = _this$props11.validation,
        addValidationError = _this$props11.addValidationError,
        removeValidationError = _this$props11.removeValidationError;
    var _this$state = this.state,
        formFieldToEdit = _this$state.formFieldToEdit,
        GDPREditorVisible = _this$state.GDPREditorVisible; // `formDescription` might be `null`, which we cannot give as a value to input components.

    var formDescriptionNotNull = formDescription || '';

    if (formFieldToEdit) {
      return _react.default.createElement(_DynoFormFieldEditorPanel.default, {
        formField: formFields.find(function (field) {
          return field.name === _this4.state.formFieldToEdit;
        }),
        closeFormFieldEditor: this.closeFormFieldEditor,
        addValidationError: addValidationError,
        removeValidationError: removeValidationError
      });
    }

    if (GDPREditorVisible) {
      return this.renderGDPREditor();
    }

    return _react.default.createElement("div", {
      className: "dyno-editor-form-panel"
    }, this.maybeRenderImageUpload(), _react.default.createElement(_UIFormControl.default, {
      id: "dyno-form-description",
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('bodyTextHeader')
      }),
      error: validation.formDescription,
      validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.formDescription)
    }, _react.default.createElement(_RichTextEditor.default, {
      contents: formDescriptionNotNull,
      gates: this.props.allGates,
      id: "rich-text-editor-form",
      onChange: this.handleFormDescriptionChange,
      minHeight: 130,
      shrink: true
    })), _react.default.createElement(_FormFieldEditor.default, {
      editFormField: this.handleEditFormField,
      locale: locale
    }), _react.default.createElement(_SimpleTextInputWithValidation.default, {
      id: "dyno-form-cta",
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('buttonTextHeader')
      }),
      labelTooltip: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('buttonTextTooltip')
      }),
      isInvalid: !(0, _ValidationUtils.isValid)(validation, 'cta'),
      invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.cta, FORM_CTA_MAX_LENGTH),
      value: formCta,
      onChange: this.handleChangeFormCtaText,
      onBlur: this.handleBlurFormCtaText
    }), _react.default.createElement(_GDPROptions.default, {
      value: this.getLegalConsentCurrentOption(),
      onChange: this.handleLegalConsentChange,
      onEdit: this.toggleGDPR
    }), _react.default.createElement(_UIFormControl.default, {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('formLanguageSelectorHeader')
      }),
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('tooltip.formLanguage')
      })
    }, _react.default.createElement(_UISelect.default, {
      className: "form-language-select",
      defaultValue: locale,
      onChange: function onChange(_ref5) {
        var value = _ref5.target.value;
        return _this4.updateLocale(formFields, value, updateDyno);
      },
      options: (0, _LocaleUtils.getLocaleOptions)(_Locales.default)
    })), this.maybeRenderLifecycleSelect(), this.renderRecaptchaToggle());
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    subscriptionsDefinitions: state.subscriptions.definitions,
    fetchingDefinitions: state.subscriptions.isFetchingDefinitions,
    fetchingDefinitionsHasError: state.subscriptions.fetchingDefinitionsHasError,
    legalConsentOptions: (0, _LegalConsent2.getLegalConsentOptions)(state),
    legalConsentDefaultSettings: new _LegalConsentDefaultSettings.default(state.legalConsentDefaultSettings, (0, _DynoUtils.getPortalDomain)(state), state.subscriptions.definitions),
    lifecycleProperty: (0, _ContactProperties.getLifecycleProperty)(state),
    allGates: state.allGates
  };
};

var actionsToBind = {
  fetchSubscriptions: _Subscriptions.fetchSubscriptionsDefinitions,
  fetchLegalConsentDefaults: _LegalConsentDefaultSettings2.fetchLegalConsentDefaultSettings
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(DynoFormPanel);

exports.default = _default;
module.exports = exports.default;